module.exports = __webpack_public_path__ + "img/vipEquityB.b59b1e25.png";